import { Component, Input, OnInit } from '@angular/core';
import { interval, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { News } from 'src/app/models/news';

@Component({
  selector: 'app-recent-slides',
  templateUrl: './recent-slides.component.html',
  styleUrls: ['./recent-slides.component.scss']
})
export class RecentSlidesComponent implements OnInit {

  @Input() newss: BehaviorSubject<News[]>;
  newsScroll : News[] = [];
  quantityNews : number = 10;
  selector : string = '.slides';

  constructor() { }

  ngOnInit(): void {
    this.newss.subscribe(data => {
      this.newsScroll = data.slice(0, this.quantityNews);
    });
  }

  onScroll() {
    this.newss.subscribe(data => {
      if(this.newsScroll.length <= data.length){
        this.quantityNews = this.quantityNews + 10;
        this.newsScroll = data.slice(0, this.quantityNews);
      }
    });
  }

}
